// §6.4 — the Windows 11 keymap, the "windows11" column of the table.
//
// Two entries differ in kind from every other skin's:
//
//  * **`launcher.open` is a bare `Meta`** — a *tap* of the Windows key, which is not a chord and
//    does not parse as one. The keyboard service skips a binding it cannot parse, so declaring it
//    here is inert until M7.4 teaches the service what a modifier tap is. It is declared anyway,
//    because §6.4 says this is where the Windows launcher lives.
//  * **`window.close` is bound twice** — `Ctrl+W` and `Alt+F4`. §6.4 lists both, and it matters:
//    the browser eats `Ctrl+W` outside immersive mode, so `Alt+F4` is the one that actually works.
import type { Keymap } from '@hangar/shared';

export const windowsKeymap: Keymap = {
  id: 'windows11',
  bindings: [
    { id: 'launcher.open', chord: 'Meta', reserved: true },
    { id: 'switcher.windows', chord: 'Alt+Tab', reserved: true },
    { id: 'switcher.overview', chord: 'Meta+Tab', reserved: true },
    { id: 'window.snapLeft', chord: 'Meta+ArrowLeft', reserved: true },
    { id: 'window.snapRight', chord: 'Meta+ArrowRight', reserved: true },
    { id: 'window.snapUp', chord: 'Meta+ArrowUp', reserved: true },
    { id: 'window.snapDown', chord: 'Meta+ArrowDown', reserved: true },
    { id: 'desktop.previous', chord: 'Meta+Ctrl+ArrowLeft', reserved: true },
    { id: 'desktop.next', chord: 'Meta+Ctrl+ArrowRight', reserved: true },
    { id: 'clipboard.history', chord: 'Meta+V', reserved: true },
    { id: 'notifications.center', chord: 'Meta+N', reserved: true },
    { id: 'shell.immersive', chord: 'F11', reserved: true },
    { id: 'shell.lock', chord: 'Meta+L', reserved: true },
    { id: 'app.explorer', chord: 'Meta+E', reserved: true },
    { id: 'app.settings', chord: 'Meta+I', reserved: true },
    { id: 'window.close', chord: 'Ctrl+W', reserved: true },
    { id: 'window.close', chord: 'Alt+F4', reserved: true },
    // §34.4 (D-505) — Quick Notes' capture card. The same chord as the house skin: `Meta+N` is the
    // platform's "new window" and `Meta+Shift+N` is already the notification centre two rows up.
    { id: 'notes.capture', chord: 'Ctrl+Alt+N', reserved: true },
  ],
};
